
import React, { useState } from 'react';

const TicTacToe: React.FC = () => {
  const [board, setBoard] = useState<(string | null)[]>(Array(9).fill(null));
  const [xIsNext, setXIsNext] = useState(true);
  const winner = calculateWinner(board);

  function calculateWinner(squares: (string | null)[]) {
    const lines = [[0, 1, 2], [3, 4, 5], [6, 7, 8], [0, 3, 6], [1, 4, 7], [2, 5, 8], [0, 4, 8], [2, 4, 6]];
    for (let i = 0; i < lines.length; i++) {
      const [a, b, c] = lines[i];
      if (squares[a] && squares[a] === squares[b] && squares[a] === squares[c]) return squares[a];
    }
    return squares.every(s => s !== null) ? 'Draw' : null;
  }

  const handleClick = (i: number) => {
    if (winner || board[i]) return;
    const nextSquares = board.slice();
    nextSquares[i] = 'X';
    setBoard(nextSquares);
    setXIsNext(false);

    // Basic AI Turn
    setTimeout(() => {
      if (calculateWinner(nextSquares)) return;
      const empty = nextSquares.map((s, idx) => s === null ? idx : null).filter(s => s !== null) as number[];
      if (empty.length > 0) {
        const aiMove = empty[Math.floor(Math.random() * empty.length)];
        nextSquares[aiMove] = 'O';
        setBoard(nextSquares);
        setXIsNext(true);
      }
    }, 400);
  };

  return (
    <div className="flex flex-col items-center">
      <h2 className="text-2xl font-bold mb-6 text-indigo-400">
        {winner === 'Draw' ? "It's a Draw!" : winner ? `Winner: ${winner}` : `Next: ${xIsNext ? 'You (X)' : 'AI (O)'}`}
      </h2>
      <div className="grid grid-cols-3 gap-2 bg-slate-900 p-4 rounded-2xl border-4 border-slate-800">
        {board.map((val, i) => (
          <button
            key={i}
            onClick={() => handleClick(i)}
            className={`w-24 h-24 flex items-center justify-center text-4xl font-black rounded-xl transition-all ${
              val === 'X' ? 'bg-indigo-600 text-white' : val === 'O' ? 'bg-slate-700 text-pink-400' : 'bg-slate-800 hover:bg-slate-700'
            }`}
          >
            {val}
          </button>
        ))}
      </div>
      <button onClick={() => setBoard(Array(9).fill(null))} className="mt-8 bg-indigo-600 hover:bg-indigo-700 px-8 py-2 rounded-full font-bold">Restart</button>
    </div>
  );
};

export default TicTacToe;
